export default __webpack_public_path__ + "static/ProValue_5@992-075bae39d253763ae1156adf087af047.webp";